import { useTranslation } from "react-i18next";
import { useSessionStore } from "@/store/session";
import logoKozien from "@/assets/logo-kozien.svg";
import logoThermototaal from "@/assets/logo-thermototaal.svg";
import logoNkm from "@/assets/logo-nkm.svg";

const LOGOS: Record<string, string> = {
    kozien: logoKozien,
    thermototaal: logoThermototaal,
    nkm: logoNkm,
};

const BRAND_NAMES: Record<string, string> = {
    kozien: "Kozien",
    thermototaal: "ThermoTotaal",
    nkm: "NKM",
};

export function SunProtectionHeader() {
    const { t } = useTranslation();
    const contact = useSessionStore((s) => s.contact);
    const contactName = [contact?.firstName, contact?.lastName]
        .filter(Boolean)
        .join(" ");

    const brandLabel = import.meta.env.VITE_PUBLIC_LABEL as string;
    const logoSrc = LOGOS[brandLabel];
    const brandName = BRAND_NAMES[brandLabel] ?? brandLabel;

    return (
        <header className="flex items-center justify-between px-6 py-4 bg-white border-b border-gray-100">
            {logoSrc ? (
                <img src={logoSrc} alt={brandName} className="h-8 w-auto" />
            ) : (
                <span className="text-lg font-bold text-gray-900">
                    {brandName}
                </span>
            )}
            {contactName && (
                <span
                    className="text-sm text-gray-700"
                    data-testid="header-greeting"
                >
                    {t("header.greeting", { name: contactName })}
                </span>
            )}
        </header>
    );
}
